import React from 'react'
import { useTranslation } from 'react-i18next'

import { CenteredLoaderContainer, Loader } from './CenteredLoader.style'

export default function CenteredLoader(props) {
  const { t } = useTranslation()
  return (
    <CenteredLoaderContainer size={props.size} data-test="centered-loader" aria-label={t('spinner')}>
      <Loader color={props.color} borderTopColor={props.borderTopColor} />
    </CenteredLoaderContainer>
  )
}
